










import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component({
  components: {},
})
export default class TabsComponent extends Vue {
  @Prop() readonly items!: any;
  @Prop({ default: 0 }) readonly selectedTab!: number;

  onTabClick(tab) {
    this.$emit('click', tab);
  }
}
